import { useId } from 'react';

import { classlist } from '~/_shared/design-system/lib/classlist';
import {
	BaseButton,
	type BaseButtonProps,
} from '~/_shared/design-system/ui/atoms/button/base/base-button';

import './primary-button.css';

type PrimaryButtonProps = BaseButtonProps;

const PrimaryButton = ({ className, id, ...rest }: PrimaryButtonProps) => {
	// Instance-unique default id (explicit `id` prop wins) — see BaseButton.
	const auto_id = useId();
	return (
		<BaseButton
			{...rest}
			id={id ?? `PrimaryButton-${auto_id}`}
			className={classlist('primary-button', className)}
		/>
	);
};

export type { PrimaryButtonProps };
export { PrimaryButton };
